<template>
  <div
    class="dynamic-flag"
    v-tooltip="{
      content: 'Dynamic flag answers change each time the lab is started.',
      placement: 'top-center',
      classes: ['dynamic-flag__tooltip'],
    }"
  >
    Dynamic Flag
    <AlertCircleIcon size="16" />
  </div>
</template>

<script>
import { AlertCircleIcon } from 'vue-feather-icons'

export default {
  name: 'DynamicFlag',
  components: {
    AlertCircleIcon,
  },
}
</script>

<style lang="scss">
.dynamic-flag {
  position: absolute;
  width: 55px;
  height: 55px;
  display: flex;
  flex-flow: column;
  justify-content: space-evenly;
  align-items: center;
  background: var(--oranger-gradient);
  font-size: 10px;
  line-height: 10px;
  text-align: center;
  clip-path: polygon(100% 0, 100% 75%, 50% 100%, 0 75%, 0 0);
  padding-bottom: 5px;

  &__tooltip {
    max-width: 250px;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
  }
}
</style>
